import Transformer, { TRANSFORM_INPUT } from "+/Engine/Transformers/Transformer";

// Serialises the resolved value to a JSON string. Used by App.json routines
// whose target field is a string but whose logical value is structured — e.g.
// DynamicComponent.rootOptions is stored as a string, so the
// CreateDynamicComponent routine assembles a nested source and runs it through
// `jsonEncode` to get the string the CreateEntity routine writes to the db.
export default class JsonEncode extends Transformer {
  // eslint-disable-next-line no-unused-vars
  assertValidInput(value, params) {
    // Any JSON.stringify-compatible value is accepted. Circular references
    // throw a TypeError inside transform() and surface via the engine's usual
    // error path, which is the right behaviour — a circular ref in a routine
    // param is a config bug, not runtime data.
  }

  // eslint-disable-next-line no-unused-vars
  [TRANSFORM_INPUT](value, params) {
    return JSON.stringify(value);
  }
}
Transformer.register("jsonEncode", JsonEncode);
